"use client";

import React from 'react';
import { useSession } from '@/context/SessionContext';
import EditNotePage from '@/pages/EditNotePage';
import { Skeleton } from '@/components/ui/skeleton';

const EditNoteWrapper: React.FC = () => {
  const { session, loading } = useSession();

  if (loading) {
    return (
      <div className="p-4 md:p-6 space-y-6">
        <Skeleton className="h-40 w-full" />
        <Skeleton className="h-60 w-full" />
      </div>
    );
  }

  return <EditNotePage session={session} />;
};

export default EditNoteWrapper;